import { ZfIcon } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

interface IProps {
    showPastEvents: boolean;
    updateDisplayedEvents: () => void;
}

export const RoadmapButton: FunctionComponent<IProps> = ({ showPastEvents, updateDisplayedEvents }) => {
    const { t } = useTranslation();

    const displayedText = showPastEvents ? t('hidePastEvents') : t('showPastEvents');
    const displayedIcon = showPastEvents ? 'check_indeterminate_small' : 'add';

    return (
        <div className="roadmap-button" style={{ height: '50px', paddingLeft: '55px', display: 'flex', alignItems: 'center' }} onClick={updateDisplayedEvents}>
            <div className="roadmap-icon">
                <ZfIcon name={displayedIcon} size="medium" />
            </div>
            <div style={{ paddingLeft: '14px' }}>{displayedText}</div>
        </div>
    );
};
